import { render, staticRenderFns } from "./companyconsol.vue?vue&type=template&id=651da174"
import script from "./companyconsol.vue?vue&type=script&lang=js"
export * from "./companyconsol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports